import React from "react";
import ReactPaginate from "react-paginate";

const Table = (props) => {
  const elementos = props.elementos;
  let id;
  if (!props.id) {
    id = "myTable";
  } else {
    id = props.id;
  }

  function sortTable(n) {
    var table,
      rows,
      switching,
      i,
      x,
      y,
      shouldSwitch,
      dir,
      switchcount = 0;
    table = document.getElementById(id);
    switching = true;
    //Set the sorting direction to ascending:
    dir = "asc";
    /*Make a loop that will continue until
        no switching has been done:*/
    while (switching) {
      //start by saying: no switching is done:
      switching = false;
      rows = table.rows;
      /*Loop through all table rows (except the
            first, which contains table headers):*/
      for (i = 1; i < rows.length - 1; i++) {
        //start by saying there should be no switching:
        shouldSwitch = false;
        /*Get the two elements you want to compare,
                one from current row and one from the next:*/
        x = rows[i].getElementsByTagName("TD")[n];
        y = rows[i + 1].getElementsByTagName("TD")[n];
        /*check if the two rows should switch place,
                based on the direction, asc or desc:*/
        if (dir === "asc") {
          if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
            //if so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        } else if (dir === "desc") {
          if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
            //if so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        /*If a switch has been marked, make the switch
                and mark that a switch has been done:*/
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        //Each time a switch is done, increase this count by 1:
        switchcount++;
      } else {
        /*If no switching has been done AND the direction is "asc",
                set the direction to "desc" and run the while loop again.*/
        if (switchcount === 0 && dir === "asc") {
          dir = "desc";
          switching = true;
        }
      }
    }

    if (dir === "asc") {
      // let indicador = document.getElementById("iconoOrder" + n)
      //
      // indicador.className = ''
      // indicador.className = 'glyphicon glyphicon-sort-by-attributes-alt'
    }
    if (dir === "desc") {
      // let indicador = document.getElementById("iconoOrder" + n)
      //
      // indicador.className = ''
      // indicador.className = 'glyphicon glyphicon-sort-by-attributes'
    }
  }

  function filtrarElementos(columna) {
    var input, filter, table, tr, td, i, j, visible;
    input = document.getElementById(id + "input");
    filter = input.value.toUpperCase();
    table = document.getElementById(id);
    tr = table.getElementsByTagName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 1; i < tr.length; i++) {
      visible = false;
      /* Obtenemos todas las celdas de la fila, no sólo la primera */
      td = tr[i].getElementsByTagName("td");
      for (j = 0; j < td.length; j++) {
        if (td[j] && td[j].textContent.toUpperCase().indexOf(filter) > -1) {
          visible = true;
        }
      }
      if (visible === true) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }

  let pageChange = (data) => {
    // let listaFiltrada = []
    // for (var i = 0; i <= 9; i++) {
    //     if (listaUnidades[data.selected * 10 + i] !== undefined) {
    //         listaFiltrada.push(listaUnidades[data.selected * 10 + i])
    //     }

    // }
    // setListaPage(listaFiltrada)

    props.setPaginadoor({
      ...props.paginadorState,
      skip: data.selected + 1,
    });
  };

  let skipChange = (event) => {
    // Al cambiar el tamaño de pagina volvemos a la primera, porque la pagina
    // anterior puede no existir con el nuevo limit (ej: estabas en pagina 5
    // con limit=5 -> 25 items; con limit=25 la pagina 5 ya no existe).
    props.setPaginadoor({
      ...props.paginadorState,
      limit: Number(event.target.value),
      skip: 1,
    });
  };

  if (props.type === 1) {
    return (
      <>
        <div className="col-md-4" style={{ paddingLeft: "0px" }}>
          <input
            type="text"
            placeholder="Buscar coincidencia"
            id={id + "input"}
            className="form-control"
            onKeyUp={(event) => {
              filtrarElementos();
            }}
          ></input>
          {props.extraAction}
        </div>
        <div className="col-md-4" style={{ paddingLeft: "0px" }}></div>

        {props.paginadorState && !props.paginationBelow && (
          <div className="col-md-4" style={{ paddingLeft: "0px" }}>
            <ReactPaginate
              style={{ zIndex: 0 }}
              previousLabel={"<  "}
              nextLabel={"  >"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={props.paginas}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={pageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />

            <select className="selectPagina" onChange={skipChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
            </select>
          </div>
        )}
      </>
    );
  } else if (props.type === 3) {
    // type=3: solo paginacion (para renderizar despues de la tabla)
    if (!props.paginadorState) return null;
    return (
      <div className="paginationBelow">
        <ReactPaginate
          style={{ zIndex: 0 }}
          previousLabel={"<  "}
          nextLabel={"  >"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={props.paginas}
          marginPagesDisplayed={1}
          pageRangeDisplayed={1}
          onPageChange={pageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />

        <select className="selectPagina" onChange={skipChange}>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
        </select>
      </div>
    );
  } else {
    return (
      <thead className="ajusteTabladata">
        <tr>
          {!props.sinId && (
            <th
              scope="col"
              id={"iconoOrder" + 0}
              style={{ cursor: "pointer" }}
              onClick={(event) => {
                sortTable(0);
              }}
            >
              {props.idName ? props.idName : "Id"}
            </th>
          )}

          {elementos.map((item, i) => {
            //
            if (item) {
              return (
                <th
                  key={i}
                  id={"iconoOrder" + i + 1}
                  scope="col"
                  style={{
                    cursor: "pointer",
                    position: "sticky",
                    width: props?.widths?.[i] || "auto",
                  }}
                  onClick={(event) => {
                    sortTable(i + 1);
                  }}
                >
                  {item}
                </th>
              );
            } else {
              return null;
            }
          })}

          {!props.sinGestion ? (
            <th scope="col" style={{ cursor: "pointer", position: "sticky" }}>
              <p>Gestión</p>
            </th>
          ) : (
            ""
          )}
        </tr>
      </thead>
    );
  }
};

/* 
<div className='col-md-12' style={{ height: 300, width: '100%' }}>
    
</div>
<Table type={1} elementos={["Nombre Activo"]}></Table>
<Table type={2} elementos={["Nombre Activo"]}></Table> 
<UserTab nombre={"Tribunales"}></UserTab>
*/

export default Table;
